function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.0601 11.2266C13.818 11.2266 13.6209 11.0297 13.6209 10.7878V10.1297H11.87V10.7878C11.87 11.0297 11.6729 11.2266 11.4308 11.2266C11.1888 11.2266 10.9917 11.0297 10.9917 10.7878V10.1297C10.9917 9.64594 11.3858 9.25781 11.8644 9.25781H13.6153C14.0995 9.25781 14.4879 9.65156 14.4879 10.1297V10.7878C14.4879 11.0297 14.2909 11.2266 14.0488 11.2266H14.0601Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.0578 15.1091C12.979 15.1372 12.8664 15.1597 12.7482 15.1597C12.6299 15.1597 12.5173 15.1372 12.4104 15.0978L7.50098 13.4609V16.7966C7.50098 17.4603 8.04146 18.0003 8.7058 18.0003H16.7961C17.4605 18.0003 18.001 17.4603 18.001 16.7966V13.4609L13.0634 15.1034L13.0578 15.1091Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.9953 11.7741V12.2409L12.8551 13.9509C12.8214 13.9622 12.7876 13.9678 12.7482 13.9678C12.7088 13.9678 12.6806 13.9678 12.6412 13.9509L7.50098 12.2409V11.7741C7.50098 11.1103 8.04146 10.5703 8.7058 10.5703H16.7961C17.4605 10.5703 18.001 11.1103 18.001 11.7741H17.9953Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M5.79351 6.37875C7.55826 6.37875 8.98888 4.95082 8.98888 3.18938C8.98888 1.42793 7.55826 0 5.79351 0C4.02876 0 2.59814 1.42793 2.59814 3.18938C2.59814 4.95082 4.02876 6.37875 5.79351 6.37875Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M5.86663 14.7291V11.1234C5.86663 10.2741 6.55417 9.58781 7.40514 9.58781H10.1215C8.97183 8.82844 7.45586 8.36719 5.78773 8.36719C3.95617 8.36719 2.29931 8.92406 1.11584 9.82406C0.39449 10.3697 0 11.2416 0 12.1472V15.0497C0 15.6178 0.462117 16.0734 1.02567 16.0734H5.86099V14.7347L5.86663 14.7291Z"
});

function SvgIconRemark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRemark);
export default __webpack_public_path__ + "static/media/icon_remark.5fddbe41.svg";
export { ForwardRef as ReactComponent };